export default {
  searchProducts: '/api/v3/discover',
  getShoppingCartInfo: '/api/v2/shoppingcart/cart-meta-info',
  getBrands: n => `/api/v1/brands?np=${n}&f=0&t=1000`,
  getCategorys: '/api/v2/productcategories',
  getMerchants: '/api/v2/merchants',
  get_promo_by_id: '/api/v1/promotions/promo',
  get_hot_words: '/api/v1/search/hot-words'
}
